export default __webpack_public_path__ + "static/media/rr8.b9d47af0.jpg";